module.exports = __webpack_public_path__ + "media/images/technology/star-icon-c6d5db223781dc288acc35784851637d.png";